import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import { actionCreators } from "./redux/serviceBookingsSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { DatePicker } from "./smartComponents/DatePicker";
import { CustomDateRanges } from "./smartComponents/CustomDateRanges";
import { DataPoints } from "./smartComponents/DataPoints";
import { addSticky } from "../../../utils/addSticky";
import ShowPercentageToggle from "./smartComponents/ShowPercentageToggle";
import { GroupByFilter } from "./smartComponents/GroupByFilter";
import YearOverYear from "./smartComponents/YearOverYear";
import GroupByTimeOfDayChart from "./smartComponents/GroupTimeOfDayChart";
import HeatMapChart from "./smartComponents/HeatMapChart";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { Dropdown } from "./smartComponents/Dropdown";
import { FutureBookings } from "./smartComponents/FutureBookings";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import NoData from "../../../components/noData/noData";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import "./ServiceBookingsModule.scss";

const ServiceBookingsModule = ({ numberOfMonths, ...restProps }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.serviceBookings.isLoading);
  const isHeatMapLoading = useSelector((state) => state.serviceBookings.isHeatMapLoading);
  const series = useSelector((state) => state.serviceBookings.series);
  const groupByTimeOfDay = useSelector((state) => state.serviceBookings.groupByTimeOfDay);
  const future_bookings = useSelector((state) => state.serviceBookings.future_bookings);
  const getData = () => {
    dispatch(
      actionCreators.fetchCurrentUser({
        currentUser: restProps,
        numberOfMonths: numberOfMonths
      })
    );
  };
  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!isLoading) {
      addSticky();
    }
  }, [isLoading]);

  return (
    <div className="service-bookings-module">
      <SectionToggle
        maxHeight="auto"
        autoHeight
        title="Service Bookings"
        customClass="class-utilization-heatmap withSticky"
        hideToggle
        isLoading={isLoading}
        learnMore={
          <KBLearnMore
            title="Service Bookings"
            description="This report shows all service-based bookings categorized by status and time period, giving you visibility into how clients engage with service appointments. These insights help you optimize staffing, improve scheduling, and identify peak times for service demand."
            kbUrl={ILEARN_URLS.services.serviceBookings}
          />
        }
        content={
          <div>
            <div className="edit-selections-bar" id="sticky-select-bar">
              <div className="selection-bar-filters">
                <div className="dates-container">
                  <div>
                    <div className="select-box-no-width">
                      <FutureBookings />
                    </div>
                  </div>
                  {future_bookings ? null : (
                    <div className="select-box-no-width date-range-select-box">
                      <p className="offers-title">Date Range</p>
                      <CustomDateRanges />
                    </div>
                  )}
                  <div className="date-select-box select-box multi" style={{ width: "286px" }}>
                    <p className="offers-title">Date</p>
                    <DatePicker />
                  </div>
                </div>
                <div className="filters-container">
                  <Dropdown
                    keyName="booking_statuses"
                    label="Booking Status"
                    width="200px"
                    skipLoader
                  />
                  <Dropdown keyName="visit_names" label="Service Name" width="200px" />
                  {future_bookings ? null : (
                    <Dropdown keyName="membership_types" label="Membership Types" width="200px" />
                  )}
                  <Dropdown keyName="staff_names" label="Staff" width="200px" />
                </div>

                <UpdateBtns />
              </div>
            </div>
            {series?.length !== 0 ? (
              <>
                <div className="content-wrapper">
                  <DataPoints />
                  <YearOverYear />
                </div>
                <div style={{ paddingTop: "50px", minHeight: "500px" }}>
                  <div className="heatmap-heading">
                    <h2>Service Bookings Heatmap</h2>
                    <div className="heatmap-filters">
                      <GroupByFilter />
                      <ShowPercentageToggle />
                    </div>
                  </div>

                  {isHeatMapLoading ? (
                    <LoadingAnimation />
                  ) : groupByTimeOfDay ? (
                    <GroupByTimeOfDayChart />
                  ) : (
                    <HeatMapChart />
                  )}
                </div>
              </>
            ) : (
              <NoData />
            )}
          </div>
        }
      />
    </div>
  );
};

export default ServiceBookingsModule;
